import { render, staticRenderFns } from "./DeletePageDialog.vue?vue&type=template&id=4dd18c2e&"
import script from "./DeletePageDialog.vue?vue&type=script&lang=js&"
export * from "./DeletePageDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeletePageDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports